/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type SuggestionActionRequestToMove_payload = {
    readonly betterTime: {
        readonly date: string;
        readonly timeSlot: TimeSlot;
    } | null;
    readonly nearestAlternateTime: {
        readonly date: string;
        readonly timeSlot: TimeSlot;
    } | null;
    readonly " $refType": "SuggestionActionRequestToMove_payload";
};
export type SuggestionActionRequestToMove_payload$data = SuggestionActionRequestToMove_payload;
export type SuggestionActionRequestToMove_payload$key = {
    readonly " $data"?: SuggestionActionRequestToMove_payload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionActionRequestToMove_payload">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SuggestionActionRequestToMove_payload",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "DayTimeSlot",
                "kind": "LinkedField",
                "name": "betterTime",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "DayTimeSlot",
                "kind": "LinkedField",
                "name": "nearestAlternateTime",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            }
        ],
        "type": "SuggestionActionRequestToMovePayload",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'c355ebb0e81c042569141f27ea4a5800';
export default node;
